import { render, staticRenderFns } from "./EtlPage.vue?vue&type=template&id=5e96075a&scoped=true&"
import script from "./EtlPage.vue?vue&type=script&lang=js&"
export * from "./EtlPage.vue?vue&type=script&lang=js&"
import style0 from "./EtlPage.vue?vue&type=style&index=0&id=5e96075a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e96075a",
  null
  
)

export default component.exports